/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { getEmployees, updateEmployee, getEmployee, hideModal } from "actions";
import toastr from "toastr";
import Select from "react-select";

class UpdateEmployee extends Component {
  state = {
    name: "",
    surname: "",
    emailAddress: "",
    position: "",
    phoneNumber: "",
    selectedEducationLevel: null,
    educationLevel: null,
    selectedBirthdate: null,
    birthdate: "",
    language: null,
    selectedLanguage: null,
    myhr: null,

    educationLevels: [
      { value: 1, label: "Clear All" },
      { value: 2, label: "Elementary" },
      { value: 3, label: "Highschool" },
      { value: 5, label: "Vocational High School" },
      { value: 6, label: "Pre-Graduate" },
      { value: 7, label: "Under Graduate" },
      { value: 8, label: "Graduate" },
      { value: 9, label: "Phd" },
    ],

    languages: [
      { value: 14337, label: "AR" },
      { value: 1031, label: "DE" },
      { value: 1033, label: "EN" },
      { value: 1034, label: "ES" },
      { value: 1036, label: "FR" },
      { value: 1050, label: "HR" },
      { value: 1049, label: "RU" },
      { value: 1055, label: "TR" },
    ],
  };

  componentDidMount() {
    this.getEmployee();
  }

  getEmployee = () => {
    this.props.getEmployee(
      this.props.employee.id,
      this.onBegin,
      this.onGetEmployeeSuccess,
      this.onError
    );
  };

  getEmployees = () => {
    this.props.getEmployees(this.onBegin, this.onSuccess, this.onError);
  };

  updateEmployee = () => {
    if (!this.checkRequirementFields()) return;

    let formData = {
      name: this.state.name,
      surname: this.state.surname,
      educationLevel: this.state.selectedEducationLevel,
      birthdate: this.state.selectedBirthdate,
      phoneNumber: this.state.phoneNumber,
      language: this.state.selectedLanguage,
      myhr: this.state.myhr,
    };

    this.props.updateEmployee(
      this.props.employee.id,
      formData,
      this.onBegin,
      this.onUpdateEmployeeSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    toastr.error(err.response.data.message);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
  };

  onGetEmployeeSuccess = (res) => {
    this.props.onProcessEnd();
    let data = res.data.data;
    this.setState({
      name: data.name,
      myhr: data.myhr,
      surname: data.surname,
      emailAddress: data.emailAddress ?? "",
      position: data.position?.name ?? "",
      phoneNumber: data.phoneNumber ?? "",
      selectedEducationLevel: data.educationLevel?.value ?? null,
      educationLevel: data.educationLevel
        ? this.state.educationLevels.find(
          (z) => z.value === data.educationLevel.value
        )
        : null,
      birthdate: data.birthdate
        ? new Date(data.birthdate).toISOString().substr(0, 10)
        : "",
      selectedLanguage: data.language?.value ?? null,
      language: data.language
        ? this.state.languages.find((z) => z.value === data.language.value)
        : null,
    });
  };

  onUpdateEmployeeSuccess = (res) => {
    toastr.success(i18n.t("10570"));
    this.getEmployees();
    this.props.onProcessEnd();
    this.props.hideModal();
  };

  checkRequirementFields = () => {
    if (this.state.name === null || this.state.name === "") {
      //Ad alanı boş bırakılamaz
      toastr.error(i18n.t("10579"));
      return false;
    }

    if (this.state.surname === null || this.state.surname === "") {
      //Soyad alanı boş bırakılamaz
      toastr.error(i18n.t("10580"));
      return false;
    }

    // if (this.state.selectedEducationLevel === null) {
    //   //Eğitim Seviyesi alanı boş bırakılamaz
    //   toastr.error(i18n.t("10584"));
    //   return false;
    // }

    return true;
  };

  renderFormHeader = () => {
    return null;
  };

  renderFormBody = () => {
    return (
      <div>
        <form>
          <div className="form-row">
            <div className="form-group col-md-6">
              <span style={{ color: "red", marginRight: "5px" }}>*</span>
              <Trans desc="Ad">10571</Trans>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder={i18n.t("10571")}
                value={this.state.name}
                onChange={(e) => this.setState({ name: e.currentTarget.value })}
              ></input>
            </div>

            <div className="form-group col-md-6">
              <span style={{ color: "red", marginRight: "5px" }}>*</span>
              <Trans desc="Soyad">10572</Trans>
              <input
                type="text"
                className="form-control"
                id="surname"
                placeholder={i18n.t("10572")}
                value={this.state.surname}
                onChange={(e) =>
                  this.setState({ surname: e.currentTarget.value })
                }
              ></input>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-6">
              <Trans desc="E-Posta Adresi">10573</Trans>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder={i18n.t("10573")}
                value={this.state.emailAddress}
                disabled="disabled"
              ></input>
            </div>

            <div className="form-group col-md-6">
              <Trans desc="MyHR: Username">myhr_username</Trans>
              <input
                type="text"
                className="form-control"
                id="myhr"
                // placeholder="Myhr"
                value={this.state.myhr}
                // disabled={localStorage.getItem("roles").includes("Manager") ? true : false}
                onChange={(e) => localStorage.getItem("roles").includes("Manager") ? this.setState({ myhr: e.currentTarget.value }) : null}
                disabled="disabled"
              ></input>
            </div>


          </div>

          <div className="form-row">
            <div className="form-group col-md-6">
              <span style={{ color: "red", marginRight: "5px" }}>*</span>
              <Trans desc="Pozisyon">10574</Trans>
              <input
                type="text"
                className="form-control"
                id="position"
                placeholder={i18n.t("10574")}
                value={this.state.position}
                disabled="disabled"
              ></input>
            </div>

            <div className="form-group col-md-6">
              <Trans desc="Telefon Numarası">10575</Trans>
              <input
                type="text"
                className="form-control"
                id="phoneNumber"
                placeholder={i18n.t("10575")}
                value={this.state.phoneNumber}
                onChange={(e) =>
                  this.setState({ phoneNumber: e.currentTarget.value })
                }
              ></input>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-6">
              <Trans desc="Eğitim Seviyesi">10576</Trans>
              <Select
                options={this.state.educationLevels}
                value={this.state.educationLevel}
                onChange={(e) =>
                  this.setState({
                    selectedEducationLevel: e.value,
                    educationLevel: e,
                  })
                }
                placeholder={i18n.t("10576")}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className="form-group col-md-6">
              <Trans desc="Doğum Tarihi">10577</Trans>
              <input
                type="date"
                className="form-control"
                id="birthdate"
                defaultValue={this.state.birthdate}
                onChange={(e) =>
                  this.setState({
                    selectedBirthdate: new Date(e.currentTarget.value),
                  })
                }
              ></input>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-6">
              <Trans desc="Dil Tercihi">
                employeemanagement_preferred-language
              </Trans>
              <Select
                options={this.state.languages}
                value={this.state.language}
                onChange={(e) =>
                  this.setState({
                    selectedLanguage: e.value,
                    language: e,
                  })
                }
                placeholder={i18n.t("employeemanagement_preferred-language")}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className="form-group col-md-6"></div>
          </div>

          <div className="form-row col-md-12">
            <span style={{ color: "red" }}>
              <Trans desc="* Doldurulması zorunludur">10595</Trans>
            </span>
          </div>
        </form>
      </div>
    );
  };

  renderFormFooter = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn-action btn-blue"
          onClick={() => this.updateEmployee()}
        >
          <Trans desc="Kaydet">10578</Trans>
        </button>
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.props.spinner}
        {this.renderFormHeader()}
        {this.renderFormBody()}
        {this.renderFormFooter()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getEmployees,
  updateEmployee,
  getEmployee,
  hideModal,
})(containsLongRunningProcess(requireAuth(UpdateEmployee)));
